import React from "react";
import { createRoot } from "react-dom/client";

// Self-hosted fonts - eliminates render-blocking external requests
import '@fontsource/heebo/300.css';
import '@fontsource/heebo/400.css';
import '@fontsource/heebo/500.css';
import '@fontsource/heebo/700.css';

import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { ErrorBoundary } from "@/components/ErrorBoundary";

// Polyfill country flag emojis for Windows/Chrome that don't support them natively
// Must be called after imports are resolved to avoid React context conflicts
import("country-flag-emoji-polyfill").then(({ polyfillCountryFlagEmojis }) => {
  polyfillCountryFlagEmojis("Twemoji Mozilla");
});

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);